import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import { states, cities, availablePeople } from '../../../utils/cities';
import Select from '../../../components/SimpleSelect/Select';

const styles = () => ({
  TextField: {
    maxWidth: '536px',
  },
  TextField_small: {
    maxWidth: '144px',
    marginRight: '24px',
  },
  Grid: {
    marginTop: 39,
  },
  input_icon: { maxWidth: '560px' },
});

const ContactForm = props => {
  const [availableState, setAvailableState] = useState([]);
  const [availableCities, setAvailableCities] = useState([]);

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    isLawyer,
    classes,
    setFieldValue,
  } = props;

  useEffect(() => {
    fetchMyAPI();
  }, []);

  async function fetchMyAPI() {
    let availableState = await states();
    setAvailableState(availableState.data);
  }

  const handleChangeStates = field => async event => {
    event.preventDefault();
    let value = event.target.value;
    try {
      let city = await cities(value);
      setAvailableCities(city.data);
      setFieldValue('estados', value);
    } catch (error) {}
  };

  const handleChangeCities = field => async event => {
    let value = event.target.value;
    setFieldValue(field, value);
  };

  return (
    <form>
      <Grid container direction="column" classes={{ root: classes.Grid }}>
        <TextField
          label="Dirección sede principal"
          id="direccion"
          type="emailtext"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.email}
          helperText={touched.email && errors.email ? errors.email : ''}
          error={touched.email && errors.email ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <Select
          handleBlur={handleBlur}
          handleChange={handleChangeStates()}
          value={values.estados}
          touchedItems={touched.specialties}
          errorsItems={errors.specialties}
          items={availableState}
          textLabel="Estados*"
        />

        <Select
          handleBlur={handleBlur}
          handleChange={handleChangeCities()}
          touchedItems={touched.municipio}
          errorsItems={errors.municipio}
          items={availableCities}
          textLabel="Municipios*"
        />

        <TextField
          label="Número teléfonico"
          id="phone_1"
          type="emailtext"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.email}
          helperText={touched.email && errors.email ? errors.email : ''}
          error={touched.email && errors.email ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />
        <TextField
          label="Teléfono Móvil"
          id="phoneMovil"
          type="emailtext"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.email}
          helperText={touched.email && errors.email ? errors.email : ''}
          error={touched.email && errors.email ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <Grid item xs container direction="row">
          <Grid item xs classes={{ root: classes.input_icon }}>
            <TextField
              label="Correo eléctronico"
              id="email"
              type="emailtext"
              variant="outlined"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.email}
              helperText={touched.email && errors.email ? errors.email : ''}
              error={touched.email && errors.email ? true : false}
              fullWidth
              classes={{ root: classes.TextField }}
            />
          </Grid>
          <Grid item>
            <div>
              <img src="../../img/profile/ayuda.png" alt="" />
            </div>
          </Grid>
        </Grid>

        <TextField
          label="Número Whatsapp"
          id="Num_whatts"
          type="emailtext"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.email}
          helperText={touched.email && errors.email ? errors.email : ''}
          error={touched.email && errors.email ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <TextField
          label="Días laborales"
          id="direccion"
          type="emailtext"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.email}
          helperText={touched.email && errors.email ? errors.email : ''}
          error={touched.email && errors.email ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />
      </Grid>

      <TextField
        label="Hasta"
        id="inicio"
        type="emailtext"
        variant="outlined"
        onBlur={handleBlur}
        onChange={handleChange}
        value={values.email}
        helperText={touched.email && errors.email ? errors.email : ''}
        error={touched.email && errors.email ? true : false}
        fullWidth
        classes={{ root: classes.TextField_small }}
      />

      <TextField
        label="Desde"
        id="fin"
        type="emailtext"
        variant="outlined"
        onBlur={handleBlur}
        onChange={handleChange}
        value={values.email}
        helperText={touched.email && errors.email ? errors.email : ''}
        error={touched.email && errors.email ? true : false}
        fullWidth
        classes={{ root: classes.TextField_small }}
      />

      <TextField
        label="Sitio de Internet o blog "
        id="blog"
        type="emailtext"
        variant="outlined"
        onBlur={handleBlur}
        onChange={handleChange}
        value={values.email}
        helperText={touched.email && errors.email ? errors.email : ''}
        error={touched.email && errors.email ? true : false}
        fullWidth
        classes={{ root: classes.TextField }}
      />

      <div className="horizontal-layout" style={{ marginTop: 15 }}>
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          // disabled={!isValid}
          classes={{ root: classes.ButtonBase }}
        >
          Guardar cambios
        </ButtonBase>
      </div>
    </form>
  );
};

export default withStyles(styles)(ContactForm);
